import React from "react"
import "./Icon.css"

// Created by Dmitry Kovalev from the Noun Project

export default props => {
  return (
    <svg
      className="Icon Icon-Record"
      x="0px"
      y="0px"
      viewBox="0 0 1133.858 1133.857"
      style={{enableBackground: "new 0 0 1133.858 1133.857"}}
      xmlSpace="preserve"
      {...props}
    >
      <title>
        {props.title || "Vinyl Record"}
      </title>
      <metadata>
        <sfw xmlns="http://ns.adobe.com/SaveForWeb/1.0/">
          <slices/>
          <sliceSourceBounds width="713.618" height="713.619" x="210.12" y="-640.274" />
        </sfw>
      </metadata>
      <switch>
        <foreignObject requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/" x="0" y="0" width="1" height="1"/>
        <g>
          <g>
            <circle cx="566.799" cy="566.928" r="14.249"/>
            <path d="M566.93,210.119c-196.749,0-356.81,160.061-356.81,356.81c0,196.749,160.061,356.81,356.81,356.81     c196.748,0.001,356.809-160.069,356.809-356.81C923.738,370.189,763.678,210.119,566.93,210.119z M492.958,258.872     l49.822,165.601c-8.055,0.312-6.179,0.328-14.013,2.057L458.427,269.59C472.349,262.912,478.585,261.379,492.958,258.872z      M315.663,370.374c25.805-33.499,57.763-60.172,93.417-79.47l91.614,145.508c-19.766,9.292-37.171,23.625-50.594,42.317     L315.663,370.374z M566.93,680.733c-62.76,0-113.814-51.053-113.814-113.813c0-62.759,51.055-113.813,113.814-113.813     s113.814,51.054,113.814,113.813C680.744,629.681,629.689,680.733,566.93,680.733z"/>
          </g>
        </g>
      </switch>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/component/atoms/Icon/Record.js